import { useState } from "react";
import "./AdminEditarParceiro.css";

function AdminEditarParceiro({
  parceiro,
  onClose,
  onSalvar
}) {
  const [nome, setNome] = useState(parceiro.nome);

  const [arquivo, setArquivo] =
    useState(null);

  const [preview, setPreview] =
    useState(null);

  const [salvando, setSalvando] =
    useState(false);

  const handleSelecionarImagem = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setArquivo(file);

    const reader = new FileReader();

    reader.onload = (event) => {
      setPreview(event.target.result);
    };

    reader.readAsDataURL(file);
  };

  const handleSalvar = async () => {
    try {
      setSalvando(true);

      let imagemFinal = parceiro.imagem;

      if (arquivo) {
        const formData = new FormData();

        formData.append(
          "imagem",
          arquivo
        );

        const uploadResponse =
          await fetch(
            "https://app.eliandroalimentos.com.br/api/imagem/upload",
            {
              method: "POST",
              body: formData
            }
          );

        const uploadData =
          await uploadResponse.json();

        if (!uploadResponse.ok) {
          throw new Error(
            "Erro ao enviar imagem"
          );
        }

        imagemFinal =
          uploadData.caminho;
      }

      const response = await fetch(
        "https://app.eliandroalimentos.com.br/api/marcas/editar",
        {
          method: "PUT",
          headers: {
            "Content-Type":
              "application/json"
          },
          body: JSON.stringify({
            id: parceiro.id,
            nome,
            imagem: imagemFinal
          })
        }
      );

      const data =
        await response.json();

      if (!response.ok) {
        throw new Error(
          data.message ||
            "Erro ao editar parceiro"
        );
      }

      onSalvar({
        ...parceiro,
        nome,
        imagem: imagemFinal
      });

    } catch (error) {
      alert(error.message);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div
      className="admin-parceiro-editar-overlay"
      onClick={onClose}
    >
      <div
        className="admin-parceiro-editar"
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <div className="admin-parceiro-header">
          <h2>
            Editar Parceiro
          </h2>

          <button
            className="fechar"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <div className="admin-parceiro-conteudo">

          <div className="campo">
            <label>Nome</label>

            <input
              value={nome}
              onChange={(e) =>
                setNome(
                  e.target.value
                )
              }
            />
          </div>

          <div className="bloco-preview">
            <h3>
              Imagem Atual
            </h3>

            <div className="preview-parceiro-AdminEditarParceiro">
              <img
                src={parceiro.imagem}
                alt=""
              />
            </div>
          </div>

          <div className="bloco-preview">
            <h3>
              Nova Imagem (1772 × 10866 px) .jpg
            </h3>

            <input
              type="file"
              accept="image/*"
              onChange={
                handleSelecionarImagem
              }
            />

            {preview && (
              <div className="preview-original-AdminEditarParceiro">
                <img
                  src={preview}
                  alt=""
                />
              </div>
            )}
          </div>

          {preview && (
            <div className="bloco-preview">
              <h3>
                Como ficará
              </h3>

              <div className="preview-parceiro-AdminEditarParceiro">
                <img
                  src={preview}
                  alt=""
                />
              </div>
            </div>
          )}
        </div>

        <div className="admin-parceiro-footer">
          <button
            className="btn-cancelar"
            onClick={onClose}
          >
            Cancelar
          </button>

          <button
            className="btn-salvar"
            onClick={handleSalvar}
            disabled={salvando}
          >
            {salvando
              ? "Salvando..."
              : "Salvar"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminEditarParceiro;